import { useAppState } from "@/modules/app/useAppContext";
import { SnowflakeJob } from "@/pages/query/SnowflakeJobs";
import { CustomWorkloadsRoot } from "./CustomWorkloadsRoot";
import { useLocation, useParams } from "react-router-dom";
import { WorkflowType } from "@/pages/query/types";
import { useBreadcrumb } from "@/components/breadcrumbs";
import { getWorkflowNavigationPrefix } from "@/pages/query/snowflake";

export const CustomWorkloadsRootWrapper = () => {
  const { enableCustomWorkloadsChartAggregation } = useAppState();
  const { workflowId, runId } = useParams();
  const location = useLocation();

  const workflowType = location.pathname.includes("/tableau-jobs")
    ? WorkflowType.TABLEAU
    : WorkflowType.CUSTOM;

  const label = workflowType === WorkflowType.TABLEAU ? "Tableau" : "Workloads";
  const prefix = getWorkflowNavigationPrefix(workflowType);

  useBreadcrumb(runId ?? (workflowId ? decodeURIComponent(workflowId) : label), {
    defaultParents: [
      { label: "Code", pathname: "/query" },
      ...(workflowId ? [{ label, pathname: prefix }] : []),
      ...(workflowId && runId
        ? [{ label: decodeURIComponent(workflowId), pathname: `${prefix}/${workflowId}` }]
        : []),
    ],
  });

  if (enableCustomWorkloadsChartAggregation) {
    return <CustomWorkloadsRoot />;
  }

  return <SnowflakeJob />;
};
